<div class="cowing-input-location">
  <div *ngIf="label.length > 0" class="cowing-input-location-label">
    {{ label | translate }}
  </div>
  <div class="cowing-input-location-container">
    <div *ngIf="iconShow  && iconName" class="cowing-input-text-icon">
      <img [src]="getIcon" alt="" />
    </div>
    <input #input *ngIf="!isForm" [ngClass]="['input-' + inputStyle, !iconShow ? 'not-padding' : '']" type="text"
      [placeholder]="placeholder" [(ngModel)]="value" (input)="onInputChange($event)" />
    <input #input *ngIf="isForm" [ngClass]="[
        (control.invalid || !valid) && control.touched ? 'input-invalid' : '',
        'input-' + inputStyle,
        !iconShow ? 'not-padding' : '',
        valid ? 'input-valid' : ''
      ]" [(ngModel)]="value" type="text" (blur)="validateLocation()" [placeholder]="placeholder"
      [formControl]="control" />
  </div>
</div>